// extracted by mini-css-extract-plugin
export default {"stepperButton":"PricingAndStockSection_stepperButton__-fUbH","tooltipContainer":"PricingAndStockSection_tooltipContainer__Lz2Tf","noShrink":"PricingAndStockSection_noShrink__lGC6f"};